import { render, staticRenderFns } from "./SignCustomerInfo.vue?vue&type=template&id=1bd4a8a6&"
import script from "./SignCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./SignCustomerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports